import React from "react";

import Button from "components/Button";

import { ButtonWrapper, Container, Content, Text, Controls } from "./styles";
import { useTranslation } from "react-i18next";

interface Props {
  title: string;
  onClose: () => void;
  onAccept: () => void;
}

function ConfirmPopup(props: Props) {
  const { title, onAccept, onClose } = props;
  const { t } = useTranslation();
  return (
    <Container>
      <Content>
        <Text>{title}</Text>
        <Controls>
          <ButtonWrapper>
            <Button text={t("actions.cancel")} onClick={onClose} height={50} />
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              text={t("actions.confirm")}
              onClick={onAccept}
              height={50}
            />
          </ButtonWrapper>
        </Controls>
      </Content>
    </Container>
  );
}

export default ConfirmPopup;
